//Create Event Component
import React, { useEffect, useState, useRef } from "react";
import CommunityAbout from "../Posts/layouts/CommunityAbout";
import CommunityTopBar from "../Posts/layouts/CommunityTopBar";
import UpcomingEvents from "../Profile/UpcomingEvents";
import EventTopBar from "./EventTopBar";
import VisibilityToggle from "../../commonComponents/visibilitytoggle";
import ImageUploader from '../../commonComponents/Imageuploader';
import SwitchToggle from '../../commonComponents/Switchtoggle';
import Form from 'react-bootstrap/Form';
import { MultiSelect } from 'primereact/multiselect';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // or any other theme
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { getUserCommunities } from "../../services/apiPosts";
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import { useLocation, useNavigate } from "react-router-dom";
import { faL } from "@fortawesome/free-solid-svg-icons";
import Validation from "../../commonComponents/Validation";
import moment, { isDate } from "moment";
import { createEvent, editEvent, getEventDetails } from "../../services/apiEvent";
import ResponsePopup from "../../commonComponents/responseSucessPopup";
import { ApiHelper } from "../../helpers/ApiHelper";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { months } from "../../utils/Month";

const CreateEvent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state || {};
    const userData = JSON.parse(localStorage.getItem('userData'));
    const communityData = JSON.parse(localStorage.getItem('communityData'));
    const [eventTitle, setEventTitle] = useState('');
    const [description, setDescription] = useState('');
    const [community, setCommunity] = useState('');
    const [startDate, setStartDate] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endDate, setEndDate] = useState('');
    const [endTime, setEndTime] = useState('');
    const [eventType, setEventType] = useState('');
    const [eventLocation, setEventLocation] = useState('');
    const [externalReg, setExternalReg] = useState(false);
    const [webUrl, setWebUrl] = useState('');
    const [capacity, setCapacity] = useState('');
    const [eventDetails, setEventDetails] = useState('');
    const [virtualLink, setVirtualLink] = useState('');
    const [address, setAddress] = useState('');
    const [profileImgArr, setProfileImgArr] = useState([]);
    const [myCommunities, setMyCommunities] = useState([]);
    const [selected, setSelected] = useState([]);
    const [proImg, setProImg] = useState('');
    const [error, setError] = useState(false);
    const [websiteError, setWebsiteError] = useState(false);
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [isCalendarEndOpen, setIsCalendarEndOpen] = useState(false);
    const [isSucess, SetSucess] = useState(false);
    const [ResponseMessage, SetResponseMessage] = useState("");
    const [zipError, setZipError] = useState(false);
    const [timeZone, setTimeZone] = useState("");
    const [zip, setZip] = useState('');
    const [locations, setLocation] = useState('');
    const eventTitleRef = useRef(null);
    const communityRef = useRef(null);
    const startDateRef = useRef(null);
    const zoneRef = useRef(null);
    const endDateRef = useRef(null);
    const startTimeRef = useRef(null);
    const endTimeRef = useRef(null);
    const descriptionRef = useRef(null);
    const capacityRef = useRef(null);
    const eventDetailsRef = useRef(null);
    const eventTypeRef = useRef(null);
    const webUrlRef = useRef(null);
    const externalRegRef = useRef(null);
    const virtualLinkRef = useRef(null);
    const addressRef = useRef(null);
    const zipRef = useRef(null);
    const locationRef = useRef(null);
    const proImgRef = useRef(null);
    const MIN_EVENT_MINUTES = 15;
    const [showDurationError, setShowDurationError] = useState(false);
    const [startMonth, setStartMonth] = useState("");
    const [startDay, setStartDay] = useState("");
    const [startYear, setStartYear] = useState("");
    const [startDateError, setStartDateError] = useState("");

    const [endMonth, setEndMonth] = useState("");
    const [endDay, setEndDay] = useState("");
    const [endYear, setEndYear] = useState("");
    const [endDateError, setEndDateError] = useState("");

    const tz31 = [
        { value: "Etc/GMT+12", label: "(UTC-12:00) Baker Island" },
        { value: "Pacific/Pago_Pago", label: "(UTC-11:00) American Samoa" },
        { value: "Pacific/Honolulu", label: "(UTC-10:00) Hawaii" },
        { value: "America/Anchorage", label: "(UTC-09:00) Alaska" },
        { value: "America/Los_Angeles", label: "(UTC-08:00) Pacific Time (US & Canada)" },
        { value: "America/Denver", label: "(UTC-07:00) Mountain Time (US & Canada)" },
        { value: "America/Chicago", label: "(UTC-06:00) Central Time (US & Canada)" },
        { value: "America/New_York", label: "(UTC-05:00) Eastern Time (US & Canada)" },
        { value: "America/Halifax", label: "(UTC-04:00) Atlantic Time (Canada)" },
        { value: "America/Argentina/Buenos_Aires", label: "(UTC-03:00) Argentina" },
        { value: "America/Noronha", label: "(UTC-02:00) Fernando de Noronha" },
        { value: "Atlantic/Cape_Verde", label: "(UTC-01:00) Cape Verde" },
        { value: "Europe/Lisbon", label: "(UTC±00:00) Western Europe Time - Lisbon" },
        { value: "Europe/Berlin", label: "(UTC+01:00)Central European Time - Berlin" },
        { value: "Europe/Kyiv", label: "(UTC+02:00) Eastern European Time - Kyiv" },
        { value: "Europe/Moscow", label: "(UTC+03:00) Moscow" },
        { value: "Asia/Tehran", label: "(UTC+03:30) Iran - Tehran" },
        { value: "Asia/Dubai", label: "(UTC+04:00) Dubai" },
        { value: "Asia/Kabul", label: "(UTC+04:30) Afghanistan - Kabul" },
        { value: "Asia/Karachi", label: "(UTC+05:00) Pakistan - Karachi" },
        { value: "Asia/Kolkata", label: "(UTC+05:30) India, Sri Lanka - Kolkata" },
        { value: "Asia/Kathmandu", label: "(UTC+05:45) Nepal - Kathmandu" },
        { value: "Asia/Dhaka", label: "(UTC+06:00)  Bangladesh, Bhutan " },
        { value: "Asia/Yangon", label: "(UTC+06:30) Myanmar - Yangon" },
        { value: "Asia/Bangkok", label: "(UTC+07:00) Thailand - Bangkok" },
        { value: "Asia/Shanghai", label: "(UTC+08:00) China , Singapore " },
        { value: "Asia/Tokyo", label: "(UTC+09:00) Japan, South Korea" },
        { value: "Australia/Darwin", label: "(UTC+09:30) Australia - Darwin" },
        { value: "Australia/Sydney", label: "(UTC+10:00) Australia - Sydney" },
        { value: "Pacific/Guadalcanal", label: "(UTC+11:00)  Solomon Islands - Guadalcanal" },
        { value: "Pacific/Auckland", label: "(UTC+12:00) New Zealand, Fiji" },
    ];

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('userData'));
        let payload = { userid: userData._id };
        fetchAllCommunities(payload);
        if (data.eventId) {

            fetchEventDetails();
        }
        
    }, []);
    const fetchAllCommunities = async (payload) => {
        let listCommunities = await getUserCommunities(payload);
        const formatted = listCommunities?.communities.map(item => ({
            name: item?.communityId?.communityName,
            code: item?.communityId?._id,
        }));

        setMyCommunities(formatted);
    };
    const fetchEventDetails = async () => {
        const formData = {
            userid: userData._id,
            eventid: data.eventId
        }
        let eventDetail = await getEventDetails(formData);
       
        setProImg(eventDetail?.event?.eventImage);
        setEventTitle(eventDetail?.event?.eventTitle);
        setDescription(eventDetail?.event?.eventShortDescription);
        setCommunity(eventDetail?.event?.communityIds);
        setTimeZone(eventDetail?.event?.timezone);
        if (eventDetail?.event?.eventStartDate) {
            const start = new Date(eventDetail.event.eventStartDate);
            setStartMonth(String(start.getMonth() + 1)); // month is 0-based
            setStartDay(String(start.getDate()));
            setStartYear(String(start.getFullYear()));
            setStartDate(start); // already in your code
        }
        if (eventDetail?.event?.eventEndDate) {
            const end = new Date(eventDetail.event.eventEndDate);
            setEndMonth(String(end.getMonth() + 1));
            setEndDay(String(end.getDate()));
            setEndYear(String(end.getFullYear()));
            setEndDate(end);
        }

        if (eventDetail?.event?.eventStartTime)
            setStartTime(moment(eventDetail?.event?.eventStartTime, "hh:mm A")); // "08:00 PM"
        else
            setStartTime(null);

        if (eventDetail?.event?.eventEndTime)
            setEndTime(moment(eventDetail?.event?.eventEndTime, "hh:mm A"));
        else
            setEndTime(null);
        
        setEventType(eventDetail?.event?.isVirtual);
        setVirtualLink(eventDetail?.event?.virtualLink);
        setAddress(eventDetail?.event?.eventAddress);
        setZip(eventDetail?.event?.zipcode);
        setLocation(eventDetail?.event?.location);
        setExternalReg(eventDetail?.event?.haveExternalRegistration);
        setWebUrl(eventDetail?.event?.websiteUrl);
        
        setCapacity(eventDetail?.event?.eventCapacity ?? "");
        setEventDetails(eventDetail?.event?.eventOverview);

        const communityIds = eventDetail?.event?.communityIds || [];


        const selectedCommunities = eventDetail?.event?.communityIds.map(item => ({
            name: item?.communityName,
            code: item?._id,
        }));
        setSelected(selectedCommunities)
        const selectedCodes = eventDetail?.event?.communityIds.map(commu => commu._id);
        setCommunity(selectedCodes)
    };
    useEffect(() => {
        const selectedCodes = selected.map(city => city.code);
        setCommunity(selectedCodes)
        
    }, [selected]);
    
    const onUploadComplete = (responseData, type) => {
        setProfileImgArr(responseData);
        setProImg(responseData)

    };
    const disablePast = current =>
        current.isSameOrAfter(moment(), "day");
    const disableEndDate = current =>
        current.isSameOrAfter(
            startDate ? moment(startDate).startOf('day') : moment().startOf('day'),
            'day'
        );
    const handleFocus = () => {
        setIsCalendarOpen(true);
    };
    const handleFocusEnd = () => {
        setIsCalendarEndOpen(true);
    };
    const handleStartDate = (selectedDate) => {
        setStartDate(selectedDate);

         const result = validateStartDateTime(selectedDate, startTime);

  if (!result.valid) {
   // alert(result.msg);
    SetResponseMessage(result.msg);
    SetSucess(true)
    setStartTime(null); // reset if needed
  }

        
    };
    const handleEndDate = (selectedDate) => {
        setEndDate(selectedDate);
        
    };
    // ✅ START DATE VALIDATION
useEffect(() => {
  if (startMonth && startDay && startYear) {
    const formatted = `${startMonth}/${startDay.padStart(2, "0")}/${startYear}`;
    const parsed = new Date(formatted);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // remove time part

    const valid =
      parsed instanceof Date &&
      !isNaN(parsed) &&
      parsed.getMonth() + 1 === parseInt(startMonth) &&
      parsed.getDate() === parseInt(startDay) &&
      parsed.getFullYear() === parseInt(startYear);

    if (valid) {
      if (parsed < today) {
        // ❌ Past date not allowed
        setStartDateError("Start date cannot be in the past");
      } else {
        // ✅ Valid and not past
        updateStartDate(startMonth, startDay, startYear);
        setStartDateError("");
      }
    } else {
      setStartDateError("Please enter a valid start date");
    }
  } else {
    setStartDateError("");
  }
}, [startMonth, startDay, startYear]);

const validateStartDateTime = (startDate, startTime) => {
  if (!startDate || !startTime) return { valid: true };

  // Merge selected date + time into one moment object
  const startDateTime = moment(startDate)
    .hour(moment(startTime).hour())
    .minute(moment(startTime).minute())
    .second(0);

  // Validation: Cannot be in past
  if (startDateTime.isBefore(moment())) {
    return { valid: false, msg: "Start date & time cannot be in the past." };
  }

  return { valid: true };
};



// ✅ END DATE VALIDATION
useEffect(() => {
  if (endMonth && endDay && endYear) {
    const formatted = `${endMonth}/${endDay.padStart(2, "0")}/${endYear}`;
    const parsed = new Date(formatted);

    const valid =
      parsed instanceof Date &&
      !isNaN(parsed) &&
      parsed.getMonth() + 1 === parseInt(endMonth) &&
      parsed.getDate() === parseInt(endDay) &&
      parsed.getFullYear() === parseInt(endYear);

    if (valid) {
      const start = new Date(`${startMonth}/${startDay}/${startYear}`);
      if (startMonth && startDay && startYear && parsed < start) {
        setEndDateError("End date must be after or same as start date");
      } else {
        updateEndDate(endMonth, endDay, endYear);
        setEndDateError("");
      }
    } else {
      setEndDateError("Please enter a valid end date");
    }
  } else {
    setEndDateError("");
  }
}, [endMonth, endDay, endYear]);



    const updateStartDate = (month, day, year) => {
        if (month && day && year) {
            const dateStr = `${year}-${month}-${String(day).padStart(2, "0")}`;
            const date = new Date(dateStr);
            if (!isNaN(date)) {
            handleStartDate(date);
            }
        }
        };

        const updateEndDate = (month, day, year) => {
        if (month && day && year) {
            const dateStr = `${year}-${month}-${String(day).padStart(2, "0")}`;
            const date = new Date(dateStr);
            if (!isNaN(date)) {
            handleEndDate(date);
            }
        }
        };

    const getDateTime = (date, time) => {
        // Guard against incompletes
        if (!date || !time) return null;

        // Combine: “2025‑07‑09” + “14:15” → moment object
        return moment(
            `${moment(date).format("YYYY-MM-DD")} ${moment(time).format("HH:mm")}`,
            "YYYY-MM-DD HH:mm"
        );
    };

    // Normalizes possibly mixed types (moment | Date | string) to Date | null
const toDateOrNull = (t) => {
  if (!t) return null;
  if (moment.isMoment(t)) return t.toDate();
  if (t instanceof Date) return t;
  const m = moment(t);
  return m.isValid() ? m.toDate() : null;
};

// Round a date up to the next interval (e.g., 15-minute slot)
function roundUpToInterval(date, interval = 15) {
  const m = moment(date).seconds(0).milliseconds(0);
  const remainder = m.minutes() % interval;
  if (remainder !== 0) m.add(interval - remainder, "minutes");
  return m.toDate();
}

// Create a time on the given date (local time)
function makeTimeForDate(dateLike, h, m = 0) {
  const base = dateLike ? moment(dateLike) : moment();
  return base.clone().hours(h).minutes(m).seconds(0).milliseconds(0).toDate();
}
    const startDateTime = getDateTime(startDate, startTime);
    const endDateTime = getDateTime(endDate, endTime);
   // Time bounds for pickers
const isStartToday = startDate && moment(startDate).isSame(moment(), "day");
const sameDay = startDate && endDate && moment(endDate).isSame(startDate, "day");

// For 15-min intervals, last visible slot is :45 to keep selection valid
const lastSlotMinute = 45;

// Start time bounds
const minStartTime = isStartToday
  ? roundUpToInterval(new Date(), 15)                       // now (rounded up)
  : makeTimeForDate(startDate || new Date(), 0, 0);         // 00:00 of start day
const maxStartTime = makeTimeForDate(startDate || new Date(), 23, lastSlotMinute);

// End time bounds
const minEndTime = sameDay && startTime
  ? moment(toDateOrNull(startTime)).add(MIN_EVENT_MINUTES, "minutes").toDate()
  : makeTimeForDate(endDate || new Date(), 0, 0);
const maxEndTime = makeTimeForDate(endDate || new Date(), 23, lastSlotMinute);



    const durationIsValid =
        startDateTime &&
        endDateTime &&
        endDateTime.diff(startDateTime, "minutes") >= MIN_EVENT_MINUTES;
    useEffect(() => {
        
        if (!durationIsValid && endTime) {
            setShowDurationError(true);
            // optionally clear endTime after short delay
            setTimeout(() => setEndTime(""), 2000);
        } else {
            setShowDurationError(false);
        }

    }, [durationIsValid, endTime])

    useEffect(() => {
        const fetchLocation = async () => {
            if (zip) {
                const result = await getLocationFromZip(zip);
                setLocation(result);
            }
        };

        fetchLocation();
    }, [zip])
    const getLocationFromZip = async (zipCode) => {

        const apiKey = process.env.REACT_APP_ZIP_API
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`;

        try {
            const response = await ApiHelper.get(url);

            // 🔒 Prevent accessing undefined when results are empty
            if (!response.data.results || response.data.results.length === 0) {
                console.warn('No results found for zip code:', zipCode);
                return '';
            }

            const components = response.data.results[0].address_components || [];

            const getComponent = (type) =>
                components.find((comp) => comp.types.includes(type))?.long_name || '';

            const streetNumber = getComponent('street_number');
            const route = getComponent('route');
            const city = getComponent('locality');
            const state = getComponent('administrative_area_level_1');
            const postalCode = getComponent('postal_code');
            const country = getComponent('country');

            
            if (city) return city;
            if (state) return state;
            if (country) return country;

            return '';
        } catch (error) {
            console.error('Geocoding API error:', error);
            return '';
        }
    };
    
   
const isValidURL = (input) => {
  try {
    // Prepend https:// if no scheme is present
    const url = input.startsWith('http://') || input.startsWith('https://')
      ? input
      : 'https://' + input;

    const parsed = new URL(url);

    // Ensure it has a valid hostname like example.com or sub.domain.com
    return /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(parsed.hostname);
  } catch (err) {
    return false;
  }
}


    const validateForm = () => {
        let isValid = true;
        setError(true);
        setWebsiteError(false);

        if (!proImg) isValid = false;
        if (!eventTitle.trim()) isValid = false;
        if (!description.trim()) isValid = false;
        if (!selected || selected.length === 0) isValid = false;
        if (!startDate) isValid = false;
        if (!endDate) isValid = false;
        if (!startTime) isValid = false;
        if (!endTime) isValid = false;

        if (!eventType) isValid = false;

        if ((eventType === "yes" || eventType === "hybrid") && !virtualLink.trim()) {
            isValid = false;
        }

        if ((eventType === "yes" || eventType === "hybrid") && virtualLink && !isValidURL(virtualLink)) {
            isValid = false;
        }

        if ((eventType === "no" || eventType === "hybrid") && !address.trim()) isValid = false;
        if ((eventType === "no" || eventType === "hybrid") && !zip.trim()) isValid = false;
        if ((eventType === "no" || eventType === "hybrid")) {
            if (!zip.trim()) {
                isValid = false;
            } else if (!/^\d{5}$/.test(zip.trim())) {
                isValid = false;
                setZipError(true); // optional: set custom error for ZIP
            } else {
                setZipError(false); // optional: reset error state
            }
        }

        if ((eventType === "no" || eventType === "hybrid") && !locations.trim()) isValid = false;

        if (!externalReg) {
            if (!webUrl.trim()) {
                setWebsiteError(true);
                isValid = false;
            } else if (!isValidURL(webUrl)) {
                setWebsiteError(true);
                isValid = false;
            }
        }

        if (!capacity) isValid = false;
        if (!eventDetails.trim()) isValid = false;

        return isValid;
    };

    const saveEvent = async (isDraft) => {

        if (!validateForm()) {
            return;
        }
        if (proImg !== "" && eventTitle !== "" && community !== "" && startDate !== "" && description !== "" &&
            endDate !== "" && capacity !== "" && eventDetails !== "" && eventType !== "") {
            
            if ((eventType === "yes" && virtualLink !== "") || (eventType === "no" && address !== "" && zip !== "" && locations !== "") || (eventType === "hybrid" && address !== "" && zip !== "" && locations !== "" && virtualLink !== "")) {

                if (!externalReg && webUrl === "") {
                    setWebsiteError(true)
                }
                else {
                    setWebsiteError(false)
                    setError(false)
                    if (data.Status === "create") {
                        saveEventApi(isDraft);
                    }
                    else {
                        EditEventApi(isDraft);
                    }

                }
            }
        }
        else {
            setError(true);
            if (eventTitle === "") {
                eventTitleRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                eventTitleRef.current?.focus();
            } else if (description === "") {
                descriptionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                descriptionRef.current?.focus();
            } else if (startDate === "") {
                startDateRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (endDate === "") {
                endDateRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (startTime === "") {
                startTimeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (endTime === "") {
                endTimeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (timeZone === "") {
                zoneRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (community === "") {
                communityRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                communityRef.current?.focus();
            } else if (capacity === "") {
                capacityRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                capacityRef.current?.focus();
            } else if (eventDetails === "") {
                eventDetailsRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                eventDetailsRef.current?.focus();
            } else if (eventType === "") {
                eventTypeRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                eventTypeRef.current?.focus();
            } else if (webUrl === "") {
                webUrlRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                webUrlRef.current?.focus();
            } else if (externalReg === "") {
                externalRegRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                externalRegRef.current?.focus();
            } else if (virtualLink === "") {
                virtualLinkRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                virtualLinkRef.current?.focus();
            } else if (address === "") {
                addressRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                addressRef.current?.focus();
            } else if (zip === "") {
                zipRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                zipRef.current?.focus();
            } else if (locations === "") {
                locationRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                locationRef.current?.focus();
            } else if (proImg === "") {
                proImgRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                proImgRef.current?.focus();
            }
        }
    }

     const saveEventApiDraft = async (isDraft) => {
            if(eventTitle !== ""){
                saveEventApi(isDraft);
            }
            else{
                SetSucess(true);
                SetResponseMessage("You haven't entered a title yet. Your can't saved without it");
            }
    }

    const saveEventApi = async (isDraft) => {
        if (startDateError || endDateError) {
            SetResponseMessage("Please correct invalid date entries before saving.");
            SetSucess(true);
            return; // 🔥 immediately stop submission
        }
        const formData = {
            title: eventTitle,
            eventimage: proImg,
            shortdescription: description,
            overview: eventDetails,
            communityids: community,
            userid: userData._id,
            startdate: startDate ? moment(startDate).format("YYYY/MM/DD") : "",
            enddate: endDate ? moment(endDate).format("YYYY/MM/DD") : "",
            starttime: startTime ? moment(startTime).format("hh:mm A") : "",
            endtime: endTime ? moment(endTime).format("hh:mm A") : "",
            isvirtual: eventType,
            virtuallink: virtualLink,
            address: address,
            zipcode: zip,
            timezone: timeZone,
            location: locations,
            externalregistration: externalReg,
            websiteurl: webUrl,
            eventcapacity: capacity,
            status: isDraft ? 1 : 2
        }
        

        let create = await createEvent(formData);
        // sics; saranya;16/6/2025; redirection to event pages, if the event saved
        if (create.status) {
            if (isDraft === false) {
                if (data.Page === "events") {
                    navigate(`/event/${communityData?.communityName.trim().replace(/\s+/g, '-').toLowerCase()}`)
                }
                else {
                    if (userData.userType === "organization")
                        navigate('/organization', { state: { TabStatus: "myEvent" } })
                    else
                        navigate('/profile', { state: { TabStatus: "myEvent" } })
                }

            }
            else {

                SetSucess(true);
                SetResponseMessage("Event saved as draft.");
            }
        }
    }
    const EditEventApi = async (isDraft) => {
if (startDateError || endDateError) {
            SetResponseMessage("Please correct invalid date entries before saving.");
            SetSucess(true);
            return; // 🔥 immediately stop submission
        }
        const formData = {
            eventid: data.eventId,
            title: eventTitle,
            eventimage: proImg,
            shortdescription: description,
            overview: eventDetails,
            communityids: community,
            userid: userData._id,
            startdate: startDate ? moment(startDate).format("YYYY/MM/DD") : "",
            enddate: endDate ? moment(endDate).format("YYYY/MM/DD") : "",
            starttime: startTime ? moment(startTime).format("hh:mm A") : "",
            endtime: endTime ? moment(endTime).format("hh:mm A") : "",
            isvirtual: eventType,
            virtuallink: virtualLink,
            address: address,
            zipcode: zip,
            timezone: timeZone,
            location: locations,
            externalregistration: externalReg,
            websiteurl: webUrl,
            eventcapacity: capacity,
            status: isDraft ? 1 : 2
        }

        let create = await editEvent(formData);
        // sics; saranya;16/6/2025; redirection to event pages, if the event saved
        if (create.status) {
            if (isDraft === false) {
                if (data.Page === "events") {
                    navigate(`/event/${communityData?.communityName.trim().replace(/\s+/g, '-').toLowerCase()}`)
                }
                else {
                    navigate('/profile', { state: { TabStatus: "myEvent" } })
                }

            }
            else {

                SetSucess(true);
                SetResponseMessage("Event saved as draft.");
            }
        }
    }

    const panelHeaderTemplate = (options) => {
        const { className, checkboxElement, filterElement, closeElement } = options;
        return (
            <div className={className} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {checkboxElement}
                    <label style={{ marginLeft: '-7px', fontSize: '13px' }}>Select All</label>
                </div>
                {filterElement}
                {closeElement}
            </div>
        );
    };

    return (

        <div >
            <EventTopBar page={data.Page} />
            <div className="community-features main ml-0 mt-4">
                <div className="contents ml-0">
                    <div className="edit-container">
                        <div className="edit profile-wrapper event-edit">
                            <div className="edit-field">
                                <label className="edit-profile-label">Event Image<sup>*</sup></label>
                                <div className="edit-field-group">
                                    <div className="form-groups">
                                        <div ref={proImgRef} className="profile-img-upload">
                                            <ImageUploader key="event" type="event" proImg={proImg ? proImg : undefined} onUploadComplete={onUploadComplete} />
                                        </div>
                                    </div>
                                    {proImg === "" && error ? (
                                        <Validation message={'Please choose event image'} />
                                    ) : null}
                                </div>
                            </div>
                            <div className="edit-field">
                                <label className="edit-profile-label">Event Title </label>
                                <div className="edit-field-group">
                                    <div className="form-group">
                                        <input ref={eventTitleRef} type="text" placeholder="Event title " className="form-control" onChange={(e) => { setEventTitle(e.target.value) }} value={eventTitle} />
                                        {eventTitle === "" && error ? (
                                            <Validation message={'Please enter event title'} />
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="edit-field">
                                <label className="edit-profile-label">Short Description Title </label>
                                <div className="edit-field-group">
                                    <div className="form-group">
                                        <input ref={descriptionRef} type="text" placeholder="Short description" className="form-control"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length <= 250) {
                                                    setDescription(value);
                                                }
                                            }} value={description} />
                                        {description === "" && error ? (
                                            <Validation message={'Please enter short description'} />
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="edit-field">
                                <label className="edit-profile-label">Community</label>
                                <div className="edit-field-group">
                                    <div ref={communityRef} className="form-group">
                                        <MultiSelect
                                            value={selected}
                                            onChange={(e) => setSelected(e.value)}
                                            options={myCommunities}
                                            optionLabel="name"
                                            placeholder="Choose community"
                                            maxSelectedLabels={3}
                                            className=""
                                            showSelectAll          // tells MultiSelect to render its select‑all checkbox
                                            panelHeaderTemplate={panelHeaderTemplate}  // inject our custom header
                                        //className="w-full md:w-20rem" 
                                        />
                                        {community.length === 0 && error ? (
                                            <Validation message={'Please choose communities'} />
                                        ) : null}

                                    </div>
                                </div>
                            </div>

                            <div class="subheading"><h4>Dates and Times</h4><span></span></div>

                            <div className="edit-field">
                                <label className="edit-profile-label">Start date </label>
                                <div className="edit-field-group">
                                    <div ref={startDateRef} className="form-group">
                                        <div className="dob-splitter">
                                            <div className="splitter-itm">
                                                <div className="form-input">
                                                <Form.Select
                                                    aria-label="Select month"
                                                    value={startMonth}
                                                    onChange={(e) => setStartMonth(e.target.value)}
                                                >
                                                    <option value="">Month</option>
                                                    {months.map((m) => (
                                                    <option key={m.value} value={m.value}>{m.label}</option>
                                                    ))}
                                                </Form.Select>
                                                </div>
                                            </div>

                                            <div className="splitter-itm">
                                                <div className="form-input">
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Day"
                                                    value={startDay}
                                                    onChange={(e) => {
                                                    const val = e.target.value;
                                                    if (val === '') setStartDay('');
                                                    else {
                                                        const num = Math.min(Math.max(parseInt(val), 1), 31);
                                                        setStartDay(num.toString());
                                                    }
                                                    }}
                                                    min="1"
                                                    max="31"
                                                />
                                                </div>
                                            </div>

                                            <div className="splitter-itm">
                                                <div className="form-input">
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Year"
                                                    value={startYear}
                                                    onChange={(e) => setStartYear(e.target.value)}
                                                    onBlur={(e) => {
                                                    const val = e.target.value;
                                                    if (val === '') return;
                                                    const num = Math.min(Math.max(parseInt(val), 1900), 2200);
                                                    setStartYear(num.toString());
                                                    }}
                                                    min="1900"
                                                   // max={new Date().getFullYear()}
                                                />
                                                </div>
                                            </div>
                                            </div>
                                            


                                        <div className="d-none">
                                            <Datetime
                                            dateFormat="MM/DD/YYYY"
                                            timeFormat={false}
                                            inputProps={{
                                                onFocus: handleFocus,
                                                placeholder: 'e.g. 01/21/2025 '
                                            }}
                                            open={isCalendarOpen}
                                            onChange={handleStartDate}
                                            value={startDate ? moment(startDate).format("MM/DD/YYYY") : ""}
                                            isValidDate={disablePast}
                                        />
                                        </div>

                                        {(!startDate || !moment(startDate).isValid()) && error ? (
                                            <Validation message="Please choose starting date" />
                                        ) : null}
                                        {startDateError && <Validation message={startDateError} />}

                                    </div>
                                </div>
                            </div>

                            <div className="edit-field">
                                <label className="edit-profile-label">Start time </label>
                                <div className="edit-field-group">
                                    <div ref={startTimeRef} className="form-group">
                                        <DatePicker
                                        selected={toDateOrNull(startTime)}
                                           
                                            onChange={(val) => setStartTime(val)}
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={15} // you can change it to 5, 10, 30 etc.
                                            timeCaption="Time"
                                            dateFormat="h:mm aa" // Format like 4:00 PM
                                            placeholderText="Select time"
                                            className="form-control w-100"
                                            minTime={minStartTime}
  maxTime={maxStartTime}
                                        />
                                        {!startTime && error ? (
                                            <Validation message="Please choose starting time" />
                                        ) : null}

                                    </div>
                                </div>
                            </div>

                            <div className="edit-field">
                                <label className="edit-profile-label">End date </label>
                                <div className="edit-field-group">
                                    <div ref={endDateRef} className="form-group">
                                       <div className="dob-splitter">
                                            <div className="splitter-itm">
                                                <div className="form-input">
                                                <Form.Select
                                                    aria-label="Select month"
                                                    value={endMonth}
                                                    onChange={(e) => setEndMonth(e.target.value)}
                                                >
                                                    <option value="">Month</option>
                                                    {months.map((m) => (
                                                    <option key={m.value} value={m.value}>{m.label}</option>
                                                    ))}
                                                </Form.Select>
                                                </div>
                                            </div>

                                            <div className="splitter-itm">
                                                <div className="form-input">
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Day"
                                                    value={endDay}
                                                    onChange={(e) => {
                                                    const val = e.target.value;
                                                    if (val === '') setEndDay('');
                                                    else {
                                                        const num = Math.min(Math.max(parseInt(val), 1), 31);
                                                        setEndDay(num.toString());
                                                    }
                                                    }}
                                                    min="1"
                                                    max="31"
                                                />
                                                </div>
                                            </div>

                                            <div className="splitter-itm">
                                                <div className="form-input">
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Year"
                                                    value={endYear}
                                                    onChange={(e) => setEndYear(e.target.value)}
                                                    onBlur={(e) => {
                                                    const val = e.target.value;
                                                    if (val === '') return;
                                                    const num = Math.min(Math.max(parseInt(val), 1900), 2200);
                                                    setEndYear(num.toString());
                                                    }}
                                                    min="1900"
                                                   // max={new Date().getFullYear()}
                                                />
                                                </div>
                                            </div>
                                            </div>
                                            {endDateError && <Validation message={endDateError} />}


                                         <div className="d-none">
                                            <Datetime
                                                dateFormat="MM/DD/YYYY"
                                                timeFormat={false}
                                                inputProps={{
                                                    onFocus: handleFocusEnd,
                                                    placeholder: 'e.g. 01/21/2025'
                                                }}
                                                open={isCalendarEndOpen}
                                                onChange={handleEndDate}
                                                value={endDate ? moment(endDate).format("MM/DD/YYYY") : ""}
                                                isValidDate={disableEndDate}
                                            />
                                        </div>
                                        
                                        {(!endDate || !moment(endDate).isValid()) && error ? (
                                            <Validation message="Please choose ending date" />
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div className="edit-field">
                                <label className="edit-profile-label">End time  </label>
                                <div className="edit-field-group">
                                    <div ref={endTimeRef} className="form-group">
                                        <DatePicker
                                        selected={toDateOrNull(endTime)}
                                           
                                            onChange={(val) => setEndTime(val)}
                                            showTimeSelect
                                            showTimeSelectOnly
                                            timeIntervals={15} // you can change it to 5, 10, 30 etc.
                                            timeCaption="Time"
                                            dateFormat="h:mm aa" // Format like 4:00 PM
                                            placeholderText="Select time"
                                            className="form-control w-100"
                                            minTime={minEndTime}
  maxTime={maxEndTime}
                                        />
                                        {!endTime && error ? (
                                            <Validation message="Please choose ending time" />
                                        ) : null}
                                       
                                        {showDurationError && (
                                            <Validation message="The end time should be after the start time" />
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="edit-field">
                                <label className="edit-profile-label">Time zone</label>
                                <div className="edit-field-group">
                                    <div className="form-group">
                                        <Form.Select
                                            aria-label="Select time zone"
                                            value={timeZone}
                                            onChange={e => setTimeZone(e.target.value)}
                                        >
                                            <option value="">Select…</option>
                                            {tz31.map(tz => (
                                                <option key={tz.value} value={tz.value}>
                                                    {tz.label}
                                                </option>
                                            ))}
                                        </Form.Select>

                                        {timeZone === "" && error ? (
                                            <Validation message={'Please enter time zone'} />
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            <div class="subheading"><h4>Event Location</h4><span></span></div>

                            <div className="edit-field">
                                <label className="edit-profile-label">Is this a Virtual event? </label>
                                <div className="edit-field-group">
                                    <div ref={eventTypeRef} className="form-group">
                                        <div className="form-control gap-3 input-radio">
                                            <div className="d-flex">
                                                <div className="d-flex">
                                                    <input type="radio" name="payment" id="vessels"
                                                        className="vesselradio form-check-input radiobtn"
                                                        value="yes" onChange={() => setEventType('yes')}
                                                        checked={eventType === 'yes'} />
                                                    <label htmlFor="vessels" className="vessel">
                                                        Yes
                                                    </label>
                                                </div>
                                                <div className="d-flex">
                                                    <input type="radio" name="payment" id="services"
                                                        className="vesselradio form-check-input"
                                                        value="no" onChange={() => setEventType('no')}
                                                        checked={eventType === 'no'} />
                                                    <label htmlFor="services" className="service">
                                                        No
                                                    </label>
                                                </div>
                                                <div className="d-flex">
                                                    <input type="radio" name="payment" id="services2"
                                                        className="vesselradio form-check-input"
                                                        value="hybrid" onChange={() => setEventType('hybrid')}
                                                        checked={eventType === 'hybrid'} />
                                                    <label htmlFor="services2" className="service">
                                                        Hybrid
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        {eventType === "" && error ? (
                                            <Validation message={'Please choose event type'} />
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            {(eventType === "yes" || eventType === "hybrid") &&
                                (<div className="edit-field">
                                    <label className="edit-profile-label">Virtual Link</label>
                                    <div className="edit-field-group">
                                        <div ref={virtualLinkRef} className="form-group">
                                            <input type="text" placeholder="Virtual link" className="form-control" onChange={(e) => { setVirtualLink(e.target.value) }} value={virtualLink} />
                                            {virtualLink === "" && error ? (
                                                <Validation message={'Please enter virtual link'} />
                                            ) : null}
                                            {virtualLink !== "" && !isValidURL(virtualLink) ? (
                                                error && <Validation message={'Please enter a valid virtual link'} />
                                            ) : null}
                                        </div>
                                    </div>
                                </div>)}

                            {(eventType === "no" || eventType === "hybrid") &&
                                (<>
                                    <div className="edit-field">
                                        <label className="edit-profile-label">Address</label>
                                        <div className="edit-field-group">
                                            <div className="form-group">
                                                <input ref={addressRef} type="text" placeholder="Event Address" className="form-control" onChange={(e) => { setAddress(e.target.value) }} value={address} />
                                                {address === "" && error ? (
                                                    <Validation message={'Please enter address'} />
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="edit-field">
                                        <label className="edit-profile-label">Zip Code</label>
                                        <div className="edit-field-group">
                                            <div className="form-group">
                                                <input ref={zipRef} type="text" placeholder="zip code" className="form-control" onChange={(e) => { setZip(e.target.value) }} value={zip}></input>
                                                {zip && !/^\d{5}$/.test(zip) && (
                                                    <Validation message="ZIP code must be exactly 5 digits" />
                                                )}
                                                {zip === "" && error ? (
                                                    <Validation message={'Please enter zip code'} />
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="edit-field">
                                        <label className="edit-profile-label">Location</label>
                                        <div className="edit-field-group">
                                            <div className="form-group">
                                                <input ref={locationRef} type="text" placeholder="Location" className="form-control" onChange={(e) => { setLocation(e.target.value) }} value={locations} ></input>
                                                {locations === "" && error ? (
                                                    <Validation message={'Please enter location'} />
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </>)}

                            <div class="subheading"><h4>External Registration  </h4><span></span></div>
                            <div className="edit-field">
                                <label className="edit-profile-label"></label>
                                <div className="edit-field-group">
                                    <div ref={externalRegRef} className="form-control gap-3 input-radio">
                                        <div className="d-flex">
                                            <div className="d-flex">
                                                <input type="checkbox" name="payment" id="vessels2"
                                                    className="vesselradio form-check-input radiobtn" onChange={(e) => { setExternalReg(e.target.checked) }} checked={externalReg} />
                                                <label htmlFor="vessels2" className="vessel">
                                                    Does not have external Registration
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>


                            {!externalReg &&
                                <div className="edit-field">
                                    <label className="edit-profile-label">Website URL</label>
                                    <div className="edit-field-group">
                                        <div className="form-group">
                                            <input ref={webUrlRef} type="text" placeholder="http:eventbrite.com  " className="form-control" onChange={(e) => { setWebUrl(e.target.value) }} value={webUrl} />
                                            {webUrl === "" && websiteError ? (
                                                <Validation message={'Please enter website url'} />
                                            ) : null}
                                            {webUrl !== "" && !isValidURL(webUrl) ? (
                                                error && <Validation message={'Please enter a valid website url'} />
                                            ) : null}
                                        </div>
                                    </div>
                                </div>}



                            <div class="subheading"><h4>Event Capacity </h4><span></span></div>

                            <div className="edit-field">
                                <label className="edit-profile-label">Total Capacity </label>
                                <div className="edit-field-group">
                                    <div className="form-group">
                                        <input ref={capacityRef} placeholder="Enter total capacity" className="form-control"
                                            type="number"
                                            min="1"
                                            step="1"
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                

                                                if (value === "") {
                                                    setCapacity("");                     // allow clearing the field
                                                    return;
                                                }

                                                if (/^\d+$/.test(value)) {             // digits only
                                                    const num = parseInt(value, 10);
                                                    if (num > 0) {                       // disallow 0
                                                        setCapacity(num);                  // store as a number
                                                    }
                                                }
                                            }} value={capacity} />
                                        {(capacity === "" || isNaN(capacity)) && error ? (
                                            <Validation message={'Please enter total capacity'} />
                                        ) : null}

                                    </div>
                                </div>
                            </div>

                            <div class="subheading"><h4>Overview </h4><span></span></div>

                            <div className="edit-field">
                                <label className="edit-profile-label">Event Details </label>
                                <div className="edit-field-group">
                                    <div ref={eventDetailsRef} className="form-group">
                                        <textarea className="form-control" onChange={(e) => { setEventDetails(e.target.value) }} value={eventDetails}></textarea>
                                        {eventDetails === "" && error ? (
                                            <Validation message={'Please enter event details'} />
                                        ) : null}

                                    </div>
                                </div>
                            </div>

                            <div className="main-action-buttons pb-5 mobile-three-btn">
                                <button className="act-buttons bg-light text-dark" onClick={() => navigate(-1)}>Cancel</button>
                                <button className="act-buttons draft" onClick={(e) => { e.preventDefault(); data.Status === "create" ? saveEventApiDraft(true) : EditEventApi(true) }} >Save Draft</button>
                                <button className="act-buttons" onClick={() => saveEvent(false)}>Post Event</button>
                            </div>



                        </div>
                    </div>
                </div>
                <CommunityAbout></CommunityAbout>
            </div>
            {isSucess && (<ResponsePopup
                isSucess={isSucess}
                CancelPopup={() => {
                    SetSucess(false);
                }}
                message={ResponseMessage}
            />)}
        </div>

    );

};
export default CreateEvent;